// extracted by mini-css-extract-plugin
export default {"text_box":"TextArea_text_box__8FJ70","text":"TextArea_text__9zhs0"};